import { Badge } from "@mantine/core";
import { useUnclearShipmentsCount } from "hooks/useUnclearShipmentsCount";
import { useTerminalManagementStore } from "../model/terminalManagementStore";

interface UnclearShipmentsBadgeProps {}

const UnclearShipmentsBadge: React.FC<UnclearShipmentsBadgeProps> = ({}) => {
  const terminalId = useTerminalManagementStore(
    store => store.selectedTerminalId
  );

  const unclearShipmentsCount = useUnclearShipmentsCount({
    terminalId,
  });

  if (!unclearShipmentsCount) {
    return null;
  }

  return (
    <Badge
      circle
      size="xs"
      bg="yellow.4"
      c="gray.8"
      p={1}
      className="font-medium flex items-center shrink-0"
    >
      {unclearShipmentsCount}
    </Badge>
  );
};

export default UnclearShipmentsBadge;
